import { useQuery } from "@tanstack/react-query";
import { fetchFeatured } from "./api/featured";

export const useGetFeatured = () => {
  return useQuery({
    queryKey: ["featured"],
    queryFn: fetchFeatured,
  });
};
